import * as actionTypes from './../Register_action.types';
import * as api from './../register_api_services/Leave_opening_balance.api'

export const getLeaveOpeningBalanceRequest = () => ({
  type: actionTypes.GET_LEAVE_OPENING_BALANCE_REQUEST,
});

export const getLeaveOpeningBalanceSuccess = (leave) => ({
  type: actionTypes.GET_LEAVE_OPENING_BALANCE_SUCCESS,
  payload: leave,
});

export const getLeaveOpeningBalanceFailure = (error) => ({
  type: actionTypes.GET_LEAVE_OPENING_BALANCE_FAILURE,
  payload: error,
});

export const fetchleaveOpeningBalance = (date) => {
  return async (dispatch) => {
    dispatch(getLeaveOpeningBalanceRequest(date));
    try {
      const leaves = await api.fetchleaveOpeningBalanceData(date);
      dispatch(getLeaveOpeningBalanceSuccess(leaves));
      console.log("leaves", leaves);

      return { success: true, data: leaves };
    } catch (error) {
      dispatch(getLeaveOpeningBalanceFailure(error));
      return { success: false, message: error };
    }
  };
};

export const updateLeaveOpeningBalanceRequest = (id, leaveData) => ({
  type: actionTypes.UPDATE_LEAVE_OPENING_BALANCE_REQUEST,
  payload: { id, leaveData },
});

export const updateLeaveOpeningBalanceSuccess = (message) => ({
  type: actionTypes.UPDATE_LEAVE_OPENING_BALANCE_SUCCESS,
  payload: message,
});

export const updateLeaveOpeningBalanceFailure = (error) => ({
  type: actionTypes.UPDATE_LEAVE_OPENING_BALANCE_FAILURE,
  payload: error,
});

export const updateLeaveOpeningBalanceById = (id, leaveData) => {
  return async (dispatch) => {
    const user = JSON.parse(sessionStorage.getItem('user'));
    leaveData.updated_by = user.user_name;

    dispatch(updateLeaveOpeningBalanceRequest(id, leaveData));
    try {
      const response = await api.updateleaveOpeningBalance(id, leaveData);
      dispatch(updateLeaveOpeningBalanceSuccess(response.message));
      return { success: true, message: response.message };
    } catch (error) {
      dispatch(updateLeaveOpeningBalanceFailure(error));
      return { success: false, message: error };
    }
  };
};



export const deleteLeaveOpeningBalanceRequest = (id) => ({
  type: actionTypes.DELETE_LEAVE_OPENING_BALANCE_REQUEST,
  payload: id,
});

export const deleteLeaveOpeningBalanceSuccess = (message) => ({
  type: actionTypes.DELETE_LEAVE_OPENING_BALANCE_SUCCESS,
  payload: message,
});

export const deleteLeaveOpeningBalanceFailure = (error) => ({
  type: actionTypes.DELETE_LEAVE_OPENING_BALANCE_FAILURE,
  payload: error,
});

export const deleteLeaveOpeningBalanceById = (id) => {
  return async (dispatch) => {
    dispatch(deleteLeaveOpeningBalanceRequest(id));
    try {
      const response = await api.deleteLeaveOpeningBalance(id);
      dispatch(deleteLeaveOpeningBalanceSuccess(response.message));
      return { success: true, message: response.message };
    } catch (error) {
      dispatch(deleteLeaveOpeningBalanceFailure(error));
      return { success: false, message: error };
    }
  };
};


export const uploadLeaveOpeningBalanceRequest = (fileData) => ({
  type: actionTypes.UPLOAD_LEAVE_OPENING_BALANCE_REQUEST,
  payload: fileData,
});

export const uploadLeaveOpeningBalanceSuccess = (message) => ({
  type: actionTypes.UPLOAD_LEAVE_OPENING_BALANCE_SUCCESS,
  payload: message,
});

export const uploadLeaveOpeningBalanceFailure = (error) => ({
  type: actionTypes.UPLOAD_LEAVE_OPENING_BALANCE_FAILURE,
  payload: error,
});

export const uploadLeaveOpeningBalanceFile = (fileData) => {
  return async (dispatch) => {
    dispatch(uploadLeaveOpeningBalanceRequest(fileData));
    try {
      const response = await api.LeaveOpeningBalanceDataUpload(fileData);
      // showSnackbar(response, 'success');      
      dispatch(uploadLeaveOpeningBalanceSuccess(response));
      return { success: true, data: response };
    } catch (error) {
      dispatch(uploadLeaveOpeningBalanceFailure(error));
      const errorMessage = error?.response?.data?.error || error?.message || 'Upload failed';
      return { success: false, error: errorMessage };
    }
  };
};

export const multiDaleteLeaveOpeningBalanceRequest = (ids) => ({
  type: actionTypes.MULTIDELETE_LEAVE_OPENING_BALANCE_REQUEST,
  payload: ids,
});

export const multiDaleteLeaveOpeningBalanceSuccess = (message) => ({
  type: actionTypes.MULTIDELETE_LEAVE_OPENING_BALANCE_SUCCESS,
  payload: message,
});

export const multiDaleteLeaveOpeningBalanceFailure = (error) => ({
  type: actionTypes.MULTIDELETE_LEAVE_OPENING_BALANCE_FAILURE,
  payload: error,
});

export const multiDeleteLeaveOpeningBalanceRecords = (ids) => {
  console.log(ids);
  return async (dispatch) => {
    dispatch(multiDaleteLeaveOpeningBalanceRequest(ids));
    try {
      const response = await api.multiDeleteleaveOpeningBalance(ids);
      // showSnackbar(response, 'success');
      dispatch(multiDaleteLeaveOpeningBalanceSuccess(response));
      return { success: true, message: response };
    } catch (error) {
      dispatch(multiDaleteLeaveOpeningBalanceFailure(error));
      return { success: false, message: error };
    }
  };
};
